import { configureStore } from '@reduxjs/toolkit';
import speechReducer from './slices/speechSlice';

export const store = configureStore({
  reducer: {
    speech: speechReducer,
  },
}); 